export default ({ job } = {}) => ({ info: { ...job } })
